export const COLORS = {
  primary: "#4bb0c0",
  secondary: "#f4a261",
  light: "#f8f9fa",
  border: "#e9ecef",
  text: "#2d3e50",
  textLight: "#6c757d",
};

export interface CompanyInfo {
  nom?: string;
  siren?: string;
  siret?: string;
  formatJuridique?: string;
  dirigeant?: string;
  chiffreAffaire?: string;
  resultat?: string;
  anneeCloture?: string;
  capital?: string;
  effectifDescription?: string;
  effectifMin?: number;
  effectifMax?: number;
  adresse?: string;
  naf_ape?: string;
}

export interface DirectoryItem {
  id: number;
  type: "user" | "client";

  // Champs User
  firstname?: string;
  name?: string;
  prenom?: string;
  nom?: string;
  email?: string;
  profession?: string;
  company?: string;

  // Adresse
  adresse?: string;
  postal_code?: string;
  country?: string;
  number?: string;

  // Premium
  is_premium_directory?: boolean;
  premium_position?: number;
  professionSetting?: any;
  profile_picture?: string;
  companyInfo?: CompanyInfo;

  // Autres champs
  show_in_directory?: boolean;
  code_NAF?: string;
  siren?: string;
  code_postal?: string;
  ville?: string;
  telephone?: string;
  raison_sociale?: string;
  tva_intra?: string;
  formatJuridique?: string;
  dirigeant?: string;
  chiffreAffaire?: string;
  resultat?: string;
  anneeCloture?: string;
  capital?: string;
  effectifDescription?: string;
  effectifMin?: number;
  effectifMax?: number;
  naf_ape?: string;
  siret?: string;
}